/*
 * ##############################################################################
 * Module Name                   : ProductMasterStatuContent
 * Purpose of the Module         :
 * Description of the Module     :
 * Original Author               :  W M Shanika Chamodi
 * Date                          : Wednesday, September 8th 2021, 10:59:50 am
 * Copyright © 2021 myPOS Software Solution (pvt Ltd.)
 * ##############################################################################
 */
import React from "react"
import { CardText, Col, Row, Label } from "reactstrap"
import DPSwitch from "framework/components/DPSwitch"

const ProductStatusContent = ({
  hideFields,
  Status_Active,
  Status_Active_OnChange,
  Status_Active_Enabled,
  Status_PosActive,
  Status_PosActive_OnChnage,
  Status_PosActive_Enable,
  Status_Purchase_OnChange,
  Status_Purchase,
  Status_Purchase_Enabled,
  Status_Open_OnChange,
  Status_Open,
  Status_Open_Enabled,
  Status_Composite_OnChange,
  Status_Composite,
  Status_Composite_Enabled,
  Status_Weighted_OnChange,
  Status_Weighted,
  Status_Weighted_Enabled,
  Status_Expiry_OnChange,
  Status_Expiry,
  Status_Expiry_Enabled,
  Status_DirectGRN_OnChange,
  Status_DirectGRN,
  Status_DirectGRN_Enabled,
  Status_MPrices_OnChange,
  Status_MPrices,
  Status_MPrices_Enabled,
  Status_priceHO_OnChange,
  Status_priceHO,
  Status_priceHO_Enabled,
  Status_FastMoving_OnChange,
  Status_FastMoving,
  Status_FastMoving_Enabled,
  Status_RawItem_OnChange,
  Status_RawItem,
  Status_RawItem_Enabled,
  Status_Discounts_OnChange,
  Status_Discounts,
  Status_Discounts_Enabled,
  Status_Minus_OnChange,
  Status_Minus,
  Status_Minus_Enabled,
  Varient_OnChange,
  Varient_Enable,
  Exchange_Enable,
  Exchange_OnChange,
  Batch_OnChange,
  Batch_enable,
  showBatch,
  showVarient,
  ProActiveDisable,
  ProPosActiveDisable,
  ProOrderActiveDisable,
  ProOpenDisable,
  ProBundleDisable,
  ProDecimalDisable,
  ProExpDisable,
  ProDIRGRNDisable,
  ProHOPriceDisable,
  ProFastMoveDisable,
  ProRawItemDisable,
  ProNoDiscDisable,
  ProMPDisable,
  ProMinusDisable,
  ProAllowExchange,
  Tab2Create,
  Tab2Modify,
  AddNew,
  emptyBottleDisable,
  emptyBottleOnchange,
  emptyBottle,
  emptyBottleEnable,
  productionPOS,
  productionPOSOnchange,
  productionPOSDisable,
  allowCostZero,
  allowCostZeroOnchange,
  allowCostZeroDisable,
  isCombineItemDisable,
  isCombineItem,
  setIsCombineItem
}) => {
  // end modal props

  return (
    <React.Fragment>
      <div>
        <Row>
          <Col sm="12">
            <CardText className="mb-0">
              <Row>
                <Col sm={12} md={6} className="mb-4-sm">
                  <Row hidden={ProActiveDisable && hideFields}>
                    <Col md={3}>
                      <DPSwitch
                        rowClass={"mb-4-sm"}
                        height={23}
                        handleDiameter={15}
                        onChange={Status_Active_OnChange}
                        checked={Status_Active}
                        disabled={Status_Active_Enabled ? true : AddNew && Tab2Create ? ProActiveDisable ? true : false : AddNew == false && Tab2Modify ? ProActiveDisable ? true : false : true}
                      />
                    </Col>
                    <Col style={{ textAlign: "left" }}>
                      <Label
                        htmlFor="example-text-input"
                        className={`col-md-12 col-form-label-sm`}
                      >
                        Active
                      </Label>
                    </Col>
                  </Row>
                  <Row hidden={ProBundleDisable && hideFields}>
                    <Col md={3}>
                      <DPSwitch
                        rowClass={"mb-4-sm"}
                        height={23}
                        handleDiameter={15}
                        onChange={Status_Open_OnChange}
                        checked={Status_Open}
                        disabled={Status_Open_Enabled ? true : AddNew && Tab2Create ? ProBundleDisable ? true : false : AddNew == false && Tab2Modify ? ProBundleDisable ? true : false : true}
                      />
                    </Col>
                    <Col style={{ textAlign: "left" }}>
                      <Label
                        htmlFor="example-text-input"
                        className={`col-md-12 col-form-label-sm`}
                      >
                        Open(Non inventory)
                      </Label>
                    </Col>
                  </Row>
                  <Row hidden={ProOpenDisable && hideFields}>
                    <Col md={3}>
                      <DPSwitch
                        rowClass={"mb-4-sm"}
                        height={23}
                        handleDiameter={15}
                        onChange={Status_Composite_OnChange}
                        checked={Status_Composite}
                        disabled={Status_Composite_Enabled ? true : AddNew && Tab2Create ? ProOpenDisable ? true : false : AddNew == false && Tab2Modify ? ProOpenDisable ? true : false : true}
                      />
                    </Col>
                    <Col style={{ textAlign: "left" }}>
                      <Label
                        htmlFor="example-text-input"
                        className={`col-md-12 col-form-label-sm`}
                      >
                        Composite items
                      </Label>
                    </Col>
                  </Row>
                  <Row hidden={ProDecimalDisable && hideFields}>
                    <Col md={3}>
                      <DPSwitch
                        rowClass={"mb-4-sm"}
                        height={23}
                        handleDiameter={15}
                        onChange={Status_Weighted_OnChange}
                        checked={Status_Weighted}
                        disabled={Status_Weighted_Enabled ? true : AddNew && Tab2Create ? ProDecimalDisable ? true : false : AddNew == false && Tab2Modify ? ProDecimalDisable ? true : false : true}
                      />
                    </Col>
                    <Col style={{ textAlign: "left" }}>
                      <Label
                        htmlFor="example-text-input"
                        className={`col-md-12 col-form-label-sm`}
                      >
                        Weighted
                      </Label>
                    </Col>
                  </Row>
                  <Row hidden={ProExpDisable && hideFields}>
                    <Col md={3}>
                      <DPSwitch
                        rowClass={"mb-4-sm"}
                        height={23}
                        handleDiameter={15}
                        onChange={Status_Expiry_OnChange}
                        checked={Status_Expiry}
                        disabled={Status_Expiry_Enabled ? true : AddNew && Tab2Create ? ProExpDisable ? true : false : AddNew == false && Tab2Modify ? ProExpDisable ? true : false : true}
                      />
                    </Col>
                    <Col style={{ textAlign: "left" }}>
                      <Label
                        htmlFor="example-text-input"
                        className={`col-md-12 col-form-label-sm`}
                      >
                        Maintain Expiry
                      </Label>
                    </Col>
                  </Row>
                  <Row hidden={ProMinusDisable && hideFields}>
                    <Col md={3}>
                      <DPSwitch
                        rowClass={"mb-4-sm"}
                        height={23}
                        handleDiameter={15}
                        onChange={Status_Minus_OnChange}
                        checked={Status_Minus}
                        disabled={Status_Minus_Enabled ? true : AddNew && Tab2Create ? ProMinusDisable ? true : false : AddNew == false && Tab2Modify ? ProMinusDisable ? true : false : true}
                      />
                    </Col>
                    <Col style={{ textAlign: "left" }}>
                      <Label
                        htmlFor="example-text-input"
                        className={`col-md-12 col-form-label-sm`}
                      >
                        Allow Minus
                      </Label>
                    </Col>
                  </Row>
                  <Row hidden={emptyBottleDisable && hideFields}>
                    <Col md={3}>
                      <DPSwitch
                        rowClass={"mb-4-sm"}
                        height={23}
                        handleDiameter={15}
                        onChange={emptyBottleOnchange}
                        checked={emptyBottle}
                        disabled={Status_Minus_Enabled ? true : AddNew && Tab2Create ? emptyBottleDisable ? true : false : AddNew == false && Tab2Modify ? emptyBottleDisable ? true : false : true}
                      />
                    </Col>
                    <Col style={{ textAlign: "left" }}>
                      <Label
                        htmlFor="example-text-input"
                        className={`col-md-12 col-form-label-sm`}
                      >
                        Return/Empty
                      </Label>
                    </Col>
                  </Row>
                  <Row hidden={productionPOSDisable && hideFields}>
                    <Col md={3}>
                      <DPSwitch
                        rowClass={"mb-4-sm"}
                        height={23}
                        handleDiameter={15}
                        onChange={productionPOSOnchange}
                        checked={productionPOS}
                        disabled={Status_Minus_Enabled ? true : AddNew && Tab2Create ? productionPOSDisable ? true : false : AddNew == false && Tab2Modify ? productionPOSDisable ? true : false : true}
                      />
                    </Col>
                    <Col style={{ textAlign: "left" }}>
                      <Label
                        htmlFor="example-text-input"
                        className={`col-md-12 col-form-label-sm`}
                      >
                        Production @ POS
                      </Label>
                    </Col>
                  </Row>
                  <Row hidden={showBatch && hideFields}>
                    <Col md={3}>
                      <DPSwitch
                        rowClass={"mb-4-sm"}
                        height={23}
                        handleDiameter={15}
                        onChange={Batch_OnChange}
                        checked={Batch_enable}
                        disabled={(Status_Minus_Enabled || !AddNew) ? true : AddNew && Tab2Create ? showBatch ? false : true : AddNew == false && Tab2Modify ? showBatch ? false : true : true}
                      />
                    </Col>
                    <Col style={{ textAlign: "left" }}>
                      <Label
                        htmlFor="example-text-input"
                        className={`col-md-12 col-form-label-sm`}
                      >
                        Batch Enable**
                      </Label>
                    </Col>
                    <Col style={{ textAlign: "left" }}>
                      <Label
                        htmlFor="example-text-input"
                        className={`col-md-12 col-form-label-sm`}
                      >
                        **Note: Once set in the creation, the status of this field is immutable.
                      </Label>
                    </Col>
                  </Row>
                </Col>
                <Col sm={12} md={6} className="mb-4-sm">

                  <Row hidden={ProDIRGRNDisable && hideFields}>
                    <Col md={3}>
                      <DPSwitch
                        rowClass={"mb-4-sm"}
                        height={23}
                        handleDiameter={15}
                        onChange={Status_DirectGRN_OnChange}
                        checked={Status_DirectGRN}
                        disabled={Status_DirectGRN_Enabled ? true : AddNew && Tab2Create ? ProDIRGRNDisable ? true : false : AddNew == false && Tab2Modify ? ProDIRGRNDisable ? true : false : true}
                      />
                    </Col>
                    <Col style={{ textAlign: "left" }}>
                      <Label
                        htmlFor="example-text-input"
                        className={`col-md-12 col-form-label-sm`}
                      >
                        Direct GRN
                      </Label>
                    </Col>
                  </Row>


                  <Row hidden={ProHOPriceDisable && hideFields}>
                    <Col md={3}>
                      <DPSwitch
                        rowClass={"mb-4-sm"}
                        height={23}
                        handleDiameter={15}
                        onChange={Status_priceHO_OnChange}
                        checked={Status_priceHO}
                        disabled={Status_priceHO_Enabled ? true : AddNew && Tab2Create ? ProHOPriceDisable ? true : false : AddNew == false && Tab2Modify ? ProHOPriceDisable ? true : false : true}
                      />
                    </Col>
                    <Col style={{ textAlign: "left" }}>
                      <Label
                        htmlFor="example-text-input"
                        className={`col-md-12 col-form-label-sm`}
                      >
                        Selling Price Controlled by HO
                      </Label>
                    </Col>
                  </Row>


                  <Row hidden={ProFastMoveDisable && hideFields}>
                    <Col md={3}>
                      <DPSwitch
                        rowClass={"mb-4-sm"}
                        height={23}
                        handleDiameter={15}
                        onChange={Status_FastMoving_OnChange}
                        checked={Status_FastMoving}
                        disabled={Status_FastMoving_Enabled ? true : AddNew && Tab2Create ? ProFastMoveDisable ? true : false : AddNew == false && Tab2Modify ? ProFastMoveDisable ? true : false : true}
                      />
                    </Col>
                    <Col style={{ textAlign: "left" }}>
                      <Label
                        htmlFor="example-text-input"
                        className={`col-md-12 col-form-label-sm`}
                      >
                        Display in fast moving screen{" "}
                      </Label>
                    </Col>
                  </Row>


                  <Row hidden={ProRawItemDisable && hideFields}>
                    <Col md={3}>
                      <DPSwitch
                        rowClass={"mb-4-sm"}
                        height={23}
                        handleDiameter={15}
                        onChange={Status_RawItem_OnChange}
                        checked={Status_RawItem}
                        disabled={Status_RawItem_Enabled ? true : AddNew && Tab2Create ? ProRawItemDisable ? true : false : AddNew == false && Tab2Modify ? ProRawItemDisable ? true : false : true}
                      />
                    </Col>
                    <Col style={{ textAlign: "left" }}>
                      <Label
                        htmlFor="example-text-input"
                        className={`col-md-12 col-form-label-sm`}
                      >
                        Raw Item
                      </Label>
                    </Col>
                  </Row>


                  <Row hidden={ProNoDiscDisable && hideFields}>
                    <Col md={3}>
                      <DPSwitch
                        rowClass={"mb-4-sm"}
                        height={23}
                        handleDiameter={15}
                        onChange={Status_Discounts_OnChange}
                        checked={Status_Discounts}
                        disabled={Status_Discounts_Enabled ? true : AddNew && Tab2Create ? ProNoDiscDisable ? true : false : AddNew == false && Tab2Modify ? ProNoDiscDisable ? true : false : true}
                      />
                    </Col>
                    <Col style={{ textAlign: "left" }}>
                      <Label
                        htmlFor="example-text-input"
                        className={`col-md-12 col-form-label-sm`}
                      >
                        Active for Discounts/Promotions
                      </Label>
                    </Col>
                  </Row>


                  <Row hidden={ProMPDisable && hideFields}>
                    <Col md={3}>
                      <DPSwitch
                        rowClass={"mb-4-sm"}
                        height={23}
                        handleDiameter={15}
                        onChange={Status_MPrices_OnChange}
                        checked={Status_MPrices}
                        disabled={Status_MPrices_Enabled ? true : AddNew && Tab2Create ? ProMPDisable ? true : false : AddNew == false && Tab2Modify ? ProMPDisable ? true : false : true}
                      />
                    </Col>
                    <Col style={{ textAlign: "left" }}>
                      <Label
                        htmlFor="example-text-input"
                        className={`col-md-12 col-form-label-sm`}
                      >
                        Multiple Prices
                      </Label>
                    </Col>
                  </Row>


                  <Row hidden={showVarient && hideFields}>
                    <Col md={3}>
                      <DPSwitch
                        rowClass={"mb-4-sm"}
                        height={23}
                        handleDiameter={15}
                        onChange={Varient_OnChange}
                        checked={Varient_Enable}
                        // disabled={Status_MPrices_Enabled ? true : AddNew && Tab2Create ? showVarient ? false : true : AddNew == false && Tab2Modify ? showVarient ? false : true : true}
                        disabled={(Status_MPrices_Enabled || !AddNew) ? true : AddNew && Tab2Create ? showVarient ? false : true : AddNew ? true : true}
                      />
                    </Col>
                    <Col style={{ textAlign: "left" }}>
                      <Label
                        htmlFor="example-text-input"
                        className={`col-md-12 col-form-label-sm`}
                      >
                        Variant Enable**
                      </Label>
                    </Col>
                  </Row>


                  <Row hidden={ProAllowExchange && hideFields}>
                    <Col md={3}>
                      <DPSwitch
                        rowClass={"mb-4-sm"}
                        height={23}
                        handleDiameter={15}
                        disabled={Status_Discounts_Enabled ? true : AddNew && Tab2Create ? ProAllowExchange ? true : false : AddNew == false && Tab2Modify ? ProAllowExchange ? true : false : true}
                        checked={Exchange_Enable}
                        onChange={Exchange_OnChange}
                      />
                    </Col>
                    <Col style={{ textAlign: "left" }}>
                      <Label
                        htmlFor="example-text-input"
                        className={`col-md-12 col-form-label-sm`}
                      >
                        Allow Exchange
                      </Label>
                    </Col>
                  </Row>

                  <Row hidden={allowCostZeroDisable && hideFields}>
                    <Col md={3}>
                      <DPSwitch
                        rowClass={"mb-4-sm"}
                        height={23}
                        handleDiameter={15}
                        disabled={Status_Discounts_Enabled ? true : AddNew && Tab2Create ? allowCostZeroDisable ? true : false : AddNew == false && Tab2Modify ? allowCostZeroDisable ? true : false : true}
                        checked={allowCostZero}
                        onChange={allowCostZeroOnchange}
                      />
                    </Col>
                    <Col style={{ textAlign: "left" }}>
                      <Label
                        htmlFor="example-text-input"
                        className={`col-md-12 col-form-label-sm`}
                      >
                        Allow Cost Zero
                      </Label>
                    </Col>
                  </Row>

                  <Row hidden={isCombineItemDisable && hideFields}>
                    <Col md={3}>
                      <DPSwitch
                        rowClass={"mb-4-sm"}
                        height={23}
                        handleDiameter={15}
                        disabled={Status_Discounts_Enabled ? true : AddNew && Tab2Create ? isCombineItemDisable ? true : false : AddNew == false && Tab2Modify ? isCombineItemDisable ? true : false : true}
                        checked={isCombineItem}
                        onChange={setIsCombineItem}
                      />
                    </Col>
                    <Col style={{ textAlign: "left" }}>
                      <Label
                        htmlFor="example-text-input"
                        className={`col-md-12 col-form-label-sm`}
                      >
                        Is Combine Item
                      </Label>
                    </Col>
                  </Row>

                </Col>
                <Col sm={12} md={1} className="mb-4-sm"></Col>
              </Row>
            </CardText>
          </Col>
        </Row>
      </div>
    </React.Fragment>
  )
}
export default ProductStatusContent
